import { render, staticRenderFns } from "./StarDisplay.vue?vue&type=template&id=1673afa8&scoped=true"
import script from "./StarDisplay.vue?vue&type=script&lang=js"
export * from "./StarDisplay.vue?vue&type=script&lang=js"
import style0 from "./StarDisplay.vue?vue&type=style&index=0&id=1673afa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673afa8",
  null
  
)

export default component.exports